import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import ProductList from '../ProductList'
import { ListSkeleton, Empty } from '@cps'
import { menuMobx } from 'restaurant'
import { themeMobx } from '@mobxStore'

import noMealImg from '@img/no-meal.png'

// interface
interface IProps {
  menuScrollTop?: number;
}
const ListTemplate: FC<IProps> = ({ menuScrollTop }) => {
  const { isLoading } = menuMobx
  return (
    <div className='list-template'>
      {
        isLoading ? <ListSkeleton /> : menuMobx.categories.length ? (
          <>
            <ProductList type='list' />
          </>
        ) : ( // 无餐品
          <Empty
            msg={themeMobx?.data?.abnormalStateSetting?.[0]?.subName || ''}
            iconType='dicon'
            iconName={themeMobx?.data?.abnormalStateSetting[0]?.icon}
            picUrl={themeMobx?.data?.abnormalStateSetting[0]?.pic || noMealImg}
            height='55vh'
          />
        )
      }
    </div>
  )
}

export default observer(ListTemplate)
